export const ReleaseInfo = Object.freeze({
  releaseVersion: '2026.2.10-1437.15',
  commitId: '0a2116010f2fe715c45c9f7a6203c9eff1ec385b',
  commitTime: '2026-02-10T14:37:15.000Z',
});
